import { parseISO } from "date-fns";
import { Classification, ClassificationResponse } from "@/common/models/classification";
import { Group } from "@/common/models/group";
import { GROUPS_ENDPOINT } from "@/common/constants";
import axios from "@/common/services/axios";

const processClassification = (raw: ClassificationResponse): Classification => ({
  id: raw.id,
  group: raw.group_id,
  player: raw.player_id,
  score: raw.score,
  created: parseISO(raw.created_at),
  updated: parseISO(raw.updated_at),
  createdBy: raw.created_by,
  updatedBy: raw.updated_by,
});

export const fetchGroupClassifications = async (group: Group): Promise<Classification[]> => {
  const response = await axios.get<ClassificationResponse[]>(
    `${GROUPS_ENDPOINT}/${group.id}/classification`,
  );
  return Array.isArray(response.data) ? response.data.map(processClassification) : [];
};
